interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

const ErrorFallback = ({ error, resetErrorBoundary }: ErrorFallbackProps) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-dark-900 px-4">
      <div className="card max-w-md w-full text-center">
        <h2 className="text-2xl font-bold text-red-400 mb-4">Something went wrong</h2>
        <p className="text-gray-400 mb-6">{error.message}</p>
        <button
          onClick={resetErrorBoundary}
          className="btn-primary w-full"
        >
          Try again
        </button>
      </div>
    </div>
  );
};

export default ErrorFallback;

